import React from "react";
import PropTypes from "prop-types";

import {black500, greyishBlue600} from "assets/jss/main";

import {UserAgentUtils} from "utils/useragent";

function SectionHeader({title, subtitle}) {
    const isMobile = UserAgentUtils.isMobile();

    return (
        <div style={{marginBottom: isMobile ? '12px': 'none'}}>
            <div style={{
                fontWeight: 700,
                color: black500,
                fontSize: isMobile ? '18px' : '20px',
                lineHeight: 'normal'
            }}>
                {title}
            </div>
            {subtitle && (
                <div style={{
                    color: greyishBlue600,
                    fontSize: isMobile ? '12px' : '14px',
                    marginTop: "4px",
                    lineHeight: 'normal'
                }}>
                    {subtitle}
                </div>
            )}
        </div>
    );
}

SectionHeader.propTypes = {
    title: PropTypes.node.isRequired,
    subtitle: PropTypes.node,
};

export default SectionHeader;
